// @types/node 없이도 타입 검사가 통과하도록 필요한 부분만 선언한다.
// 번들러가 치환하지 않는 환경도 있으므로 typeof 로 방어한다.
declare const process: { env?: { NODE_ENV?: string } } | undefined;

/** 개발 모드 여부 — 진단 로그를 프로덕션 번들에서 조용히 만든다 */
export function isDev(): boolean {
  return typeof process === 'undefined' || process?.env?.NODE_ENV !== 'production';
}
